export default __webpack_public_path__ + "static/media/Bodoni-72-Book-Italic.69f56969d1525abc3717e261900a9225.ttf";